module.exports = __webpack_public_path__ + "static/media/thank-you.0b371276.png";